import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'

// Vendors / suppliers. /club/vendors. Linked to products (vendorId) and POs.
//   {id}: { name, salesRep, phone, email, terms, brands, notes, createdAt }
const BASE = 'club/vendors'

export function watchVendors(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }

export async function createVendor(d) {
  const name = String(d.name || '').trim()
  if (!name) throw new Error('Vendor name is required.')
  const node = push(tref(BASE))
  await set(node, {
    id: node.key, name, salesRep: String(d.salesRep || '').trim(), phone: String(d.phone || '').trim(),
    email: String(d.email || '').trim(), terms: String(d.terms || '').trim(),
    brands: String(d.brands || '').trim(), notes: String(d.notes || '').trim(), createdAt: Date.now(),
  })
  logActivity({ type: 'vendor', icon: '🏭', text: `Vendor added: ${name}` })
  return node.key
}

export async function updateVendor(id, patch) {
  const clean = {}
  for (const k of ['name', 'salesRep', 'phone', 'email', 'terms', 'brands', 'notes']) if (patch[k] != null) clean[k] = String(patch[k]).trim()
  await update(tref(`${BASE}/${id}`), clean)
}

export async function deleteVendor(id) { await remove(tref(`${BASE}/${id}`)) }
